import { render, staticRenderFns } from "./Qlik.vue?vue&type=template&id=ec3ec548&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec3ec548')) {
      api.createRecord('ec3ec548', component.options)
    } else {
      api.reload('ec3ec548', component.options)
    }
    module.hot.accept("./Qlik.vue?vue&type=template&id=ec3ec548&", function () {
      api.rerender('ec3ec548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/partnerIcons/Qlik.vue"
export default component.exports